// src/routes/KaafiPayRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Intro from '../pages/kaafipay/intro';

const KaafiPayRoutes = () => {
  return (
    <Routes>
      <Route path="/intro" element={<Intro />} />
    </Routes>
  );
};

export default KaafiPayRoutes;
